// Ignora mayúsculas/minúsculas, ignora los acentos y trata correctamente la letra ñ
// Puede recibir por parámetro el nombre del atributo por el que ordenar, siendo 'name' por defecto.
export function sortByLocaleEsBase(list, field = 'name') {
  return list.slice().sort((a, b) => {
    // slice: evita mutar el array original
    const aValue = (a?.[field] ?? '').toString()
    const bValue = (b?.[field] ?? '').toString()

    return aValue.localeCompare(bValue, 'es-ES', {
      sensitivity: 'base',
    })
  })
}
